import React, { useCallback, useState } from 'react';
import { Card } from 'antd';
import DeprecationTable from './DeprecationTable';
import DeprecationScheduleModal from './DeprecationScheduleModal';
import { useQuery } from 'react-query';
import { getDepreciationListByAssetID } from '../../../../services/finassets';
import { isNil } from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';

type AssetDeprecationProps = {
  assetid?: number;
  currcode?: string;
  isActive?: boolean;
};

const AssetDeprecation = (props: AssetDeprecationProps) => {
  const { assetid, currcode,isActive } = props;

  const [selectedContextId, setSelectedContextId] = useState<
    number | undefined
  >();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { data: deprecations } = useQuery(
    ['getDepreciationListByAssetID', { assetid }],
    () =>
      getDepreciationListByAssetID({ assetid: assetid! }).then(
        (res) => res.list || []
      ),
    {
      enabled: !isNil(assetid) && isActive !== false,
    }
  );

  const selectedDeprecation = selectedContextId
    ? deprecations?.find(({ contextid }) => contextid === selectedContextId)
    : undefined;

  const onOpenSchedule = useCallback(
    (deprecation) => {
      setSelectedContextId(deprecation.contextid);
      setIsModalVisible(true);
    },
    [setSelectedContextId, setIsModalVisible]
  );

  return (
    <>
      <Card title={<GetLabel label="assetDeprecations" style={{fontWeight:'bold',paddingLeft:15}}/>}>
        <DeprecationTable
          deprecations={deprecations}
          onOpenSchedule={onOpenSchedule}
          currcode={currcode}
        />
      </Card>
      <DeprecationScheduleModal
        deprecation={selectedDeprecation}
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
        }}
        currcode={currcode}
      />
    </>
  );
};

export default AssetDeprecation;
